"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOlapicData = exports.initialOlapicDataContext = exports.OlapicDataProvider = exports.OlapicDataContext = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve */

const initialOlapicDataContext = exports.initialOlapicDataContext = {
  apiKey: '',
  hideCaption: false,
  isOpenDetails: false,
  mediaItems: [],
  setMediaItems: () => {},
  loadMoreUrl: undefined,
  setLoadMoreUrl: () => {},
  activeMedia: '',
  setActiveMedia: () => {}
};
const OlapicDataContext = exports.OlapicDataContext = /*#__PURE__*/(0, _react.createContext)(initialOlapicDataContext);
const OlapicDataProvider = ({
  children,
  mediaItems: mediaItemsProp,
  loadMoreUrl: loadMoreUrlProp,
  apiKey,
  hideCaption
}) => {
  const [mediaItems, setMediaItems] = (0, _react.useState)(mediaItemsProp);
  const [loadMoreUrl, setLoadMoreUrl] = (0, _react.useState)(loadMoreUrlProp);
  const [activeMedia, setActiveMedia] = (0, _react.useState)('');
  const value = (0, _react.useMemo)(() => ({
    mediaItems,
    setMediaItems,
    loadMoreUrl,
    setLoadMoreUrl,
    isOpenDetails: Boolean(activeMedia),
    activeMedia,
    setActiveMedia,
    apiKey,
    hideCaption
  }), [mediaItems, setMediaItems, loadMoreUrl, setLoadMoreUrl, activeMedia, setActiveMedia, apiKey, hideCaption]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(OlapicDataContext.Provider, {
    value: value,
    children: children
  });
};
exports.OlapicDataProvider = OlapicDataProvider;
const useOlapicData = () => (0, _react.useContext)(OlapicDataContext);
exports.useOlapicData = useOlapicData;
